import React from "react";
import Bootstrap from "./features/bootstrap/Bootstrap";
import Loading from "./components/dataTable/Loading";
import SessioneInScadenza from "./features/SessioneInScadenza";
import SessioneScaduta from "./features/SessioneScaduta";
import {AppHRProps} from "./App";
import RetribPage from "./pages/PVA/pva.retribuzione.page";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import LavoratoriRetribPage from "./pages/lavoratori/Lavoratori.retrib.page";
import "iframe-resizer/js/iframeResizer.contentWindow";

const AppPVARetribuzioni: React.FC<AppHRProps> = ({isBoot, isRunning, isTrust, appState, minutiDiInattivita}) => {
    const sfondo = {
        //"background": `url('${process.env.PUBLIC_URL}/images/File_001.jpeg')`,
        "background": `url('${process.env.PUBLIC_URL}/images/banner-img.jpg')`,
        "backgroundSize": "cover",
        "backgroundRepeat": "no-repeat",
        "backgroundPosition": "center",
    }
    return (
        <>
            {isBoot && <Bootstrap/>}
            {!isBoot && <>
                {!isRunning &&
                    <div className="bg-gray-100">
                    </div>
                }
                {isRunning &&
                    <div className="bg-gray-100 p-1 sm:text-sm">
                        <Loading loading={appState === 'ISEXPIRING' || appState === 'EXPIRED'}
                                 spinner={appState === 'ISEXPIRING' ? <SessioneInScadenza/> : <SessioneScaduta/>}>
                            <BrowserRouter basename="/HR">
                                <Routes>
                                    <Route path="/" element={<RetribPage/>}/>
                                    <Route path="*" element={<LavoratoriRetribPage/>}/>
                                </Routes>
                            </BrowserRouter>
                        </Loading>
                    </div>
                }
            </>
            }
        </>
    );
}
export default AppPVARetribuzioni;